import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const ProjectData = {

    getProject:async()=>{
        console.log("API Called");
        try{
            const response = await instance.get("/projects");
            console.log("Project Info Response: ",response.data);
            return response.data;
        }catch(error){
            console.log("Error fetching the Project Info",error);
            throw error;
        }
    }
    
};

export default ProjectData;